import { useQuery } from "@tanstack/react-query"
import { IPoint } from "../../../../hooks/react-query/usePatrimonyChart";
import api from "../../../../services/api"

interface IStockHistoricalDividends {
  dividends: {
    values: IPoint[]
    maxValue: number;
    minValue: number;
  }
  total: number
}

export const useStockHistoricalDividends = (stock_id: string) => {
  const query = useQuery(['stock-historical-dividends', stock_id], async () => {
    const response = await api.get<IStockHistoricalDividends>(`/stocks/get-stock-historical-dividends/${stock_id}`)

    return response.data
  })

  return query
}
